import history from 'store/CreateHistory';
import { getProductCatalogFilterOptions } from 'features/orderHistory/OrderHistory.utils';

export const getReportAnalyticsCells = (reportAnalyticsData) => reportAnalyticsData.map((row) => Object.entries(row).reduce((acc, [key, value]) => ({
  ...acc,
  [key]: (key.toLowerCase().includes('date') && value) ? new Date(value).toUTCString() : value,
}), {}));

export const formatDate = (date) => date?.split('/').join('-');

export const getRequestParamsForReportAnalytics = (appliedFilters, productsList, pageNo, rows) => {
  const {
    startDate, endDate, searchText, selectedProduct,
  } = appliedFilters;
  const { reportType, structureType } = productsList.find((product) => product.id === selectedProduct) || {};
  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
    ...(pageNo ? { pageNo } : {}),
    ...(rows ? { rows } : {}),
    ...(searchText !== '' ? { searchText } : {}),
    ...(reportType ? { reportType } : {}),
    ...(structureType ? { structureType } : {}),
  };
};

export const setQueryValuesToCustomURLParams = (basePath, appliedFilters, pageNo, rows) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const queryParams = {
    startDate: formatDate(appliedFilters.startDate),
    endDate: formatDate(appliedFilters.endDate),
    ...(appliedFilters.searchText !== '' ? { searchText: appliedFilters.searchText } : {}),
    ...(appliedFilters.selectedProduct ? { selectedProduct: appliedFilters.selectedProduct } : {}),
    ...(pageNo ? { pageNo } : {}),
    ...(rows ? { rows } : {}),
  };
  Object.entries(queryParams).forEach(([key, value]) => {
    urlSearchParams.set(key, value);
  });

  history.replace(`${basePath}?${urlSearchParams.toString().replace('=null', '')}`);
};

// #genai same exclusion set as Order History product filter
export const getProductsListForReportAnalytics = (products) => (
  getProductCatalogFilterOptions(products, { includeCategoryMeta: true })
);

export const getQueryParamsFromURL = () => {
  const urlSearchParams = new URLSearchParams(history.location.search);
  return Array.from(urlSearchParams.entries())
    .reduce((params, [key, value]) => (
      value && value !== 'null' ? { ...params, [key]: value } : params
    ), {});
};
